import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) { navigate("/admin/login"); return; }
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        setUser(res.data);
        window.history.replaceState({}, document.title, "/admin");
        if (res.data.is_admin) navigate("/admin", { replace: true, state: { user: res.data } });
        else navigate("/admin/login", { replace: true, state: { error: "not_admin" } });
      } catch {
        navigate("/admin/login", { replace: true, state: { error: "failed" } });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen bg-onyx-black flex items-center justify-center text-white/70">
      <Loader2 className="animate-spin mr-3" /> Signing you in…
    </div>
  );
}
